import {IPlaylist} from '@interfaces/playlist';
import {ViewType} from '@shared/enums/view-type.enum';

export class GetSelectedPlaylistById {
  static readonly type = '[Playlist] Get playlist by id';

  constructor(public id: number) {
  }
}

export class GetPlaylists {
  static readonly type = '[Playlist] Get all playlists';
}

export class CleanSelectedPlaylist {
  static readonly type = '[Playlist] Clean selected playlist';
}


export class SetSelectedPlaylist {
  static readonly type = '[Playlist] Set Selected Playlists';

  constructor(public playlist: IPlaylist | null) {
  }
}

export class SetPlaylistCurrentPage {
  static readonly type = '[Playlist] Set playlists current page';

  constructor(public page: number) {
  }
}

export class ChangePlaylistCurrentPage {
  static readonly type = '[Playlist] Change playlists current page';

  constructor(public page: number) {
  }
}

export class ChangeSearchPlaylistParam {
  static readonly type = '[Playlist] Change search param';

  constructor(public param: string) {
  }
}

export class UpdatePlaylist {
  static readonly type = '[Playlist] Update playlist';

  constructor(public id: number, public payload: {
    name?: string, description?: string,
    mediasToDelete?: number[], mediasToCreate?: any[], stripesToCreate?: any[],
    stripesToDelete?: number[]
  }) {
  }
}

export class ChangePlaylistPerPage {
  static readonly type = '[Playlist] Change playlist per page';

  constructor(public playlistPerPage: number) {
  }
}

export class SetPlaylistPerPage {
  static readonly type = '[Playlist] Set playlist per page';

  constructor(public playlistPerPage: number) {
  }
}

export class CleanSearchPlaylistParam {
  static readonly type = '[Playlist] Clean search params';
}

export class SetPlaylistViewType {
  static readonly type = '[Playlist] Set playlist view type';

  constructor(public viewType: ViewType | string) {
  }
}

export class ChangePlaylistViewType {
  static readonly type = '[Playlist] Change playlist view type';

  constructor(public viewType: ViewType) {
  }
}

export class DeletePlaylist {
  static readonly type = '[Playlist] Delete playlist by id';

  constructor(public id: number) {
  }
}

export class SetPlaylistsOrder {
  static readonly type = '[Playlists] set order';

  constructor(public order: string) {
  }
}

export class SetPlaylistsDefaultPerPage {
  static readonly type = '[Playlists] Set default per page value for playlists';
}

export class CleanPlaylists {
  static readonly type = '[Playlists] Clean playlists';
}
